module.exports = __webpack_public_path__ + "img/a2-s11.e3ae0c1e.jpg";